import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.9994 5.5C22.3193 5.5 20.6567 5.65375 19.4329 5.80323C17.676 6.01785 16.1313 7.15021 15.507 8.88825C14.8307 10.7713 13.8938 13.9803 13.3039 18.514C12.997 20.8732 14.6656 23.0304 17.0812 23.2355C18.6992 23.3729 21.0054 23.5 23.9994 23.5C26.9934 23.5 29.2995 23.3729 30.9176 23.2355C33.3331 23.0304 35.0018 20.8732 34.6948 18.514C34.105 13.9803 33.1681 10.7713 32.4918 8.88825C31.8675 7.15021 30.3228 6.01785 28.5659 5.80323C27.3421 5.65375 25.6795 5.5 23.9994 5.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.4994 24.5C10.8193 24.5 9.15673 24.6537 7.93292 24.8032C6.17596 25.0178 4.63131 26.1502 4.00704 27.8883C3.33068 29.7713 2.39381 32.9803 1.80395 37.514C1.49699 39.8732 3.16565 42.0304 5.58116 42.2355C7.19924 42.3729 9.50535 42.5 12.4994 42.5C15.4934 42.5 17.7995 42.3729 19.4176 42.2355C21.8331 42.0304 23.5018 39.8732 23.1948 37.514C22.605 32.9803 21.6681 29.7713 20.9918 27.8883C20.3675 26.1502 18.8228 25.0178 17.0659 24.8032C15.8421 24.6537 14.1795 24.5 12.4994 24.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M35.4994 24.5C33.8193 24.5 32.1567 24.6537 30.9329 24.8032C29.176 25.0178 27.6313 26.1502 27.007 27.8883C26.3307 29.7713 25.3938 32.9803 24.8039 37.514C24.497 39.8732 26.1656 42.0304 28.5812 42.2355C30.1992 42.3729 32.5054 42.5 35.4994 42.5C38.4934 42.5 40.7995 42.3729 42.4176 42.2355C44.8331 42.0304 46.5018 39.8732 46.1948 37.514C45.605 32.9803 44.6681 29.7713 43.9918 27.8883C43.3675 26.1502 41.8228 25.0178 40.0659 24.8032C38.8421 24.6537 37.1795 24.5 35.4994 24.5Z"
    }, null, -1)
  ])))
}
export default { render: render }